export default __webpack_public_path__ + "static/media/sans.c98efbc0.jpg";